import { useEffect, useState } from "react";
import { Alert, Button, Input, Form, Select } from "antd";

import type { SelectProps } from "antd";
import {
  isValidSACellphone,
  saCellphoneFormRule,
  saTelephoneFormRule,
} from "../../utils/systemValidation";
import WizardStepLayout from "./WizardStepLayout";
interface StepProps {
  memberAge: number;
  gotoStep: Function;
  current: number;
  form: any;
}

const sourceOfFunds: SelectProps["options"] = [
  {
    name: "Salary",
    label: "Salary",
    value: "Salary",
  },
  {
    name: "Pension",
    label: "Pension",
    value: "Pension",
  },
  {
    name: "Business Income",
    label: "Business Income",
    value: "Business Income",
  },
  {
    name: "Dividend",
    label: "Dividend",
    value: "Dividend",
  },
  {
    name: "Savings",
    label: "Savings",
    value: "Savings",
  },
  {
    name: "Other",
    label: "Other",
    value: "Other",
  },
];

const AdditionalInfo: React.FC<StepProps> = ({
  memberAge,
  gotoStep,
  current,
  form,
}) => {
  const [isOtherSelected, setIsOtherSelected] = useState(false);
  const cellphone = Form.useWatch("Cellphone", form);
  const hasInvalidLegacyCellphone =
    cellphone != null &&
    String(cellphone).trim() !== "" &&
    !isValidSACellphone(cellphone);

  const onChangeFunds = (e: string) => {
    if (e === "Other") {
      setIsOtherSelected(true);
    } else {
      setIsOtherSelected(false);
    }
  };

  useEffect(() => {
    const { SourceOfFunds } = form.getFieldsValue("SourceOfFunds");

    if (SourceOfFunds && SourceOfFunds.value === "Other") {
      setIsOtherSelected(true);
    }
  });

  const handleNext = () => {
    const fields = ["TelNumber", "Cellphone", "SourceOfFunds"];
    if (isOtherSelected) {
      fields.push("OtherSourceOfFunds");
    }

    form
      .validateFields(fields)
      .then(() => gotoStep(current + 1))
      .catch(() => {});
  };

  const tailLayout = {
    labelCol: { span: 8 },
    wrapperCol: { offset: 8, span: 8 },
  };

  const content = (
    <WizardStepLayout
      action={
        <Form.Item {...tailLayout} style={{ marginBottom: 0 }}>
          <Button block size="large" onClick={handleNext}>
            Next
          </Button>
        </Form.Item>
      }
    >
      <Form.Item
        name="TelNumber"
        label="Telephone Number"
        rules={[saTelephoneFormRule]}
      >
        <Input size="large" placeholder="Telephone Number" />
      </Form.Item>
      {hasInvalidLegacyCellphone && (
        <Alert
          type="warning"
          showIcon
          style={{ marginBottom: 16 }}
          message="Invalid cellphone number"
          description="This member has a cellphone number that is not in valid SA format. Correct it below before saving or activating the policy."
        />
      )}
      <Form.Item
        name="Cellphone"
        label="Cellphone"
        help="SA mobile format: 0821234567 or +27821234567"
        rules={[saCellphoneFormRule]}
      >
        <Input size="large" placeholder="Cellphone" />
      </Form.Item>
      <Form.Item name="Email" label="Email">
        <Input size="large" placeholder="Email" />
      </Form.Item>

      <Form.Item
        name="SourceOfFunds"
        label="Source Of Funds"
        rules={[
          {
            required: true,
          },
        ]}
      >
        <Select
          onChange={(e) => onChangeFunds(e)}
          options={sourceOfFunds}
          style={{ width: "100%" }}
          size="large"
          placeholder="Select Source Of Funds"
        />
      </Form.Item>

      {isOtherSelected && (
        <Form.Item
          name="OtherSourceOfFunds"
          label="Other"
          rules={[
            { required: true, message: "Please enter the source of funds" },
          ]}
        >
          <Input size="large" placeholder="Enter the source of funds" />
        </Form.Item>
      )}
    </WizardStepLayout>
  );

  return content;
};
export default AdditionalInfo;
